// Guard against a second registration when multiple Home hero sections render on the same page
if (!customElements.get('home-hero')) {
  class HomeHero extends HTMLElement {
    constructor() {
      super();
      // Only set cheap defaults here. No DOM reads/writes.
      this._raf = null;
      this._ro = null;
      this._mo = null;
      this._initialized = false;
    }

    connectedCallback() {
      // Read attributes & cache nodes after we’re in the DOM.
      this.fullWidthText = this.getAttribute('data-layout') === 'layout-large-text';
      if (!this.fullWidthText) return;

      this.heading = this.querySelector('.home-hero__heading');
      this.span = this.heading?.querySelector('span');
      if (!this.heading || !this.span) return;

      // First pass after paint to keep LCP fast.
      requestAnimationFrame(() => {
        this.setSize();
        this._initObservers();
        this._initialized = true;
      });
    }

    disconnectedCallback() {
      // Tidy up
      if (this._ro) this._ro.disconnect();
      if (this._mo) this._mo.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _initObservers() {
      // Resize: respond to viewport, root and element changes without thrash.
      this._ro = new ResizeObserver(() => this._scheduleMeasure());
      this._ro.observe(document.documentElement);
      this._ro.observe(this);
      this._ro.observe(this.heading);

      // If your heading text gets split/updated later, observe for DOM changes.
      this._mo = new MutationObserver(() => this._scheduleMeasure());
      this._mo.observe(this.heading, { childList: true, subtree: true });
    }

    _scheduleMeasure() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.setSize());
    }

    setSize() {
      const span = this.span || this.heading?.querySelector('span');
      if (!span) return;

      // If web fonts aren’t ready, re-run when they are to avoid jumpiness.
      if (document.fonts && document.fonts.status !== 'loaded') {
        document.fonts.ready.then(() => this._scheduleMeasure());
      }

      // Use clientWidth (more stable during early paint than innerWidth).
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const headingWidth = span.offsetWidth;
      if (!headingWidth) return;

      const fontSizePx = parseFloat(getComputedStyle(span).fontSize) || 16;
      const vw = (((viewportWidth / headingWidth) * fontSizePx) / viewportWidth) * 100 + 1;

      span.style.fontSize = `${vw}vw`;
    }
  }

  customElements.define('home-hero', HomeHero);
}
